import {parse} from "date-fns"
import {datetimeFormat, logoutMessages, subPaths} from "@/utils/consts";
import {Router, useRouter} from "vue-router";

// POST /login 失敗時の value オブジェクト。文言・ロック判定はすべてバックエンドが決定し、
// フロントエンドはそのまま描画するだけ（フロント側で閾値や文言を持たない）。
// ApiResponse.value は他エンドポイント（2FA, reset token等）でも使い回されるため any のままとし、
// ログイン失敗時のみここへキャストして使用する。
export interface LoginFailureValue {
    message: string
    failed_count: number
    retry_after_seconds: number
    is_locked: boolean
    is_permanently_locked: boolean
    locked_until: string
}

export class ApiResponse {
    data: any
    description = ""
    errorMessage = ""
    executedAt = new Date()
    result = ""
    value: any
    status = 0

    get isAuthorized (): boolean {
        return this.status === 200
    }

    get isSuccessful (): boolean {
        return this.result === "success"
    }

    static fromJson(obj: any): ApiResponse {
        const resp = new ApiResponse()
        resp.description = obj.description
        resp.errorMessage = obj.error_message
        resp.executedAt = parse(obj.executed_at, datetimeFormat, new Date())
        // console.log(obj.executed_at, resp.executedAt)
        resp.value = obj.value
        resp.result = obj.result
        return resp
    }
}